import {Component, OnInit} from "@angular/core";
import {FormBuilder} from "@angular/forms";
import {GlobalPreferences} from "../../core/helpers/global-data";
import {AuthService} from "../../core/services/auth.service";
import {GeographyControllerService} from "../../core/api/controllers/geography-controller.service";
import {MixpanelService} from "../../core/services/mixpanel.service";
import {NotificationService} from "../../core/services/notification.service";
import {ShopControllerService} from "../../core/api/controllers/shop-controller.service";
import {MatDialog} from "@angular/material/dialog";
import {AccountControllerService} from "../../core/api/controllers/account-controller/account-controller.service";
import {ISettingsDTO} from "../../shared/DTOs/ISettingsDTO";
import {ActivatedRoute, Router} from "@angular/router";

const ACCOUNT_PANEL_STORAGE_KEY = "settingsAccountPanelOpen";

@Component({
  selector: "app-settings",
  templateUrl: "./settings.component.html",
  styleUrls: ["./settings.component.scss"],
  providers: [ShopControllerService, GeographyControllerService],
})
export class SettingsComponent implements OnInit {
  image = null;
  profilePicture;
  settingsData: ISettingsDTO;
  isLoading;
  showQuickbooks = false;
  paymentData: any;
  accountPanelOpen = localStorage.getItem(ACCOUNT_PANEL_STORAGE_KEY) !== "false";

  constructor(
    public accountController: AccountControllerService,
    private notificationService: NotificationService,
    public global: GlobalPreferences,
    private formBuilder: FormBuilder,
    private mixpanelService: MixpanelService,
    private authService: AuthService,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.mixpanelService.track("settings_screen", {});
    this.getData();
  }

  getData() {
    this.isLoading = true;
    this.accountController.getUserSettings().subscribe(
      (response) => {
        this.settingsData = response;

        if (this.settingsData.username == "kevin") {
          this.showQuickbooks = true;
        }
        this.profilePicture = response.profilePictureUrl;
        this.isLoading = false;
      },
      (error) => {
        this.notificationService.error(error);
        this.isLoading = false;
      },
    );
  }

  toggleAccountPanel() {
    this.accountPanelOpen = !this.accountPanelOpen;
    localStorage.setItem(
      ACCOUNT_PANEL_STORAGE_KEY,
      String(this.accountPanelOpen),
    );
  }

  openSubscriptionPaymentModal() {
    this.router.navigateByUrl("/update-payment-info");
  }

  get isSuperAdmin() {
    return this.authService.checkTokenAccess("SuperAdmin");
  }
}
